module.exports = __webpack_public_path__ + "r-v3/img/sticker_10_icon.54017c4d.svg";